import { Directive, ElementRef, OnInit, inject } from '@angular/core';


const HOST_SELECTOR_CLASS_PAIR: {attribute: string; classes: string[]}[] = [
    {
        attribute: 'arc-btn',
        classes: ['arc-btn'],
    },
    {
        attribute: 'arc-btn-outline',
        classes: ['arc-btn', 'arc-btn-outline'],
    },
    {
        attribute: 'arc-btn-plain',
        classes: ['arc-btn', 'arc-btn-plain'],
    },
];

@Directive({ selector: 'button[arc-btn],button[arc-btn-plain],button[arc-btn-outline],a[arc-btn],a[arc-btn-plain],a[arc-btn-outline]' })
export class ArcBtnDirective implements OnInit {
    private element = inject(ElementRef);


    constructor() {
    }

    ngOnInit() {
        const nativeElement = this.element.nativeElement;

        // For each of the variant selectors that is present in the button's host
        // attributes, add the correct corresponding MDC classes.
        for (const {attribute, classes} of HOST_SELECTOR_CLASS_PAIR) {
            if (nativeElement.hasAttribute(attribute)) {
                nativeElement.classList.add(...classes);
            }
        }

        const wrapper = document.createElement("div");
        wrapper.classList.add('arc-btn-content');
        wrapper.append(...nativeElement.childNodes);
        nativeElement.appendChild(wrapper);

    }

}
